import { AbstractEntityMapper } from '@pf/shared-services';
import {
    PutAwayListCreate,
    PutAwayListDto,
    PutAwayListRead,
    PutAwayListSearchParams,
} from '../../entities/put-away-list.dto';
import { Injectable } from '@angular/core';
import { PlatformWmsMapper } from '../platform-wms.mapper';
import { PutAwayListMetadataMap } from './put-away-list.mapping-profile';

@Injectable()
export class PutAwayListMapper extends AbstractEntityMapper<
    PutAwayListRead,
    PutAwayListCreate,
    PutAwayListDto,
    PutAwayListSearchParams
> {
    constructor() {
        super(
            PutAwayListDto,
            PlatformWmsMapper,
            PutAwayListMetadataMap.symbols
        );
    }
}
